import styled from 'styled-components';

const HeroFilerCtaWrapper = styled.div`
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.1);
  padding: 2.5em;
  background: ${props => props.theme.colors.white['900']};
  div.headline {
    color: ${props => props.theme.colors.black['100']};
    font-size: 28px;
    font-weight: 500;
    line-height: 130%;
  }
  div.value-props {
    ul, ol, li {
      padding-left: 0;
      padding-right: 0;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 0;
    }
    li {
      display: flex;
      align-items: center;
      margin-bottom: 1.25em;
      line-height: 120%;
      font-size: 15px;
      color: ${props => props.theme.colors.gray['500']}
    }
    svg {
      height: 28px;
      width: 28px;
      min-height: 28px;
      min-width: 28px;
      max-height: 28px;
      max-width: 28px;
      margin-right: 0.75em;
      &, path {
        fill: ${props => props.theme.colors.orange['500']};
      }
    }
    path {
      fill: ${props => props.theme.colors.brand['500']};
    }
  }
  div.action {
    display: flex;
    justify-content: center;
    a, a:hover {
      background: linear-gradient(270deg,#ff863b -65.78%, #f66161 45.1%);
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
      border: none;
      border-bottom: 4px solid #d13f3f;
      border-radius: 6px;
      margin: 0.5em 0 0;
      width: 100%;
    }
  }

  div.num-starts {
    text-align: center;
    color: ${props => props.theme.colors.gray['900']}
  }

  @media (max-width: 45em) {
    padding: 2em;
    margin-left: -1.5em;
    margin-right: -1.5em;
    box-shadow: 0 0 15px -5px rgba(0, 0, 0, 0.15);
    div.headline {
      font-size: 24px;
    }
  }
`;

export default HeroFilerCtaWrapper;
